<template>
	<div>
		<div class="item">
			<canvas id="referenceImage_canvas1" v-bind:width="width" v-bind:height="height" tabindex="1" @click="changeLayout" />
			<!-- <div>
				<label for>参考图</label>
			</div> -->
		</div>

		<div class="item">
			<canvas id="referenceImage_canvas2" v-bind:width="width" v-bind:height="height" @mousedown="mousedown" @mouseup="mouseup" tabindex="2" />
			<!-- <div>
				<label for>缺陷图(左键切换参考图)</label>
			</div> -->
		</div>
		<!-- <el-row style="margin-top: 20px;border-top: 1px #cacaca solid;padding-top: 20px;">
			<el-col :span="12">
				<div class="form">
					<div class="form-item"><input type="text" placeholder="输入批次号" /> <button @click="searchBatch">搜索</button></div>
					<div class="form-item"><input type="text" placeholder="输入质量追溯码" /> <button @click="searchDefect">搜索</button></div>
				</div>
			</el-col>
			<el-col :span="12"> </el-col>
		</el-row> -->
	</div>
</template>

<script>
	export default {
		props: {
			image1: {
				type: String,
				required: false,
			},
			image2: {
				type: String,
				required: false,
			},
			defectSize: {
				type: Array,
				required: false,
			},
		},
		data() {
			return {
				width: (document.body.clientHeight - 370) / 2,
				height: (document.body.clientHeight - 370) / 2,
				canvas1: null,
				canvas2: null,
			}
		},
		watch: {
			image1(dataURLs) {
				if (!this.canvas1) return
				this.drawImage(this.canvas1, dataURLs)
			},
			image2(dataURLs) {
				if (!this.canvas2) return
				this.drawImage(this.canvas2, dataURLs)
			},
			defectSize(value) {},
		},
		methods: {
			// searchBatch() {
			// 	alert('功能未实现。')
			// },
			// searchDefect() {
			// 	alert('功能未实现。')
			// },
			/**
			 * 修改版图。
			 */
			changeLayout() {
				this.$emit('changeLayout')
			},
			/**
			 * 缺陷图鼠标按下之后，显示参考图。
			 */
			mousedown() {
				this.drawImage(this.canvas2, this.image1)
			},
			/**
			 * 缺陷图鼠标释放后，恢复显示缺陷图。
			 */
			mouseup() {
				this.drawImage(this.canvas2, this.image2)
			},
			/**
			 *
			 */
			drawImage(cav, imgDataUri) {
				var cxt = cav.getContext('2d')
				cxt.clearRect(0, 0, this.width, this.height)

				var image = new Image()
				image.src = imgDataUri
				image.onload = () => {
					cxt.drawImage(image, 0, 0, this.width, this.height)

					this.drawDefectRect()
				}
			},
			/**
			 * 绘制缺陷矩形框。
			 */
			drawDefectRect() {
				var x = this.canvas2.width / 2 - this.defectSize[0] / 2
				var y = this.canvas2.height / 2 - this.defectSize[1] / 2

				if (isNaN(x) || isNaN(y)) return

				var ctx = this.canvas2.getContext('2d')
				ctx.strokeStyle = '#f00'
				ctx.strokeRect(x, y, this.defectSize[0], this.defectSize[1])
			},
		},
		mounted() {
			this.canvas1 = document.getElementById('referenceImage_canvas1')
			this.canvas2 = document.getElementById('referenceImage_canvas2')

			//绘制缺陷位置。
			this.drawDefectRect()
		},
	}
</script>

<style scoped>
	.item {
		user-select: none;
		height: 285px;
	}

	.item canvas {
		background-color: #333;
		border: 1px #7d7d7d dotted;
	}

	.item label {
		display: block;
		color: #000;
	}

	.form .form-item {
		margin-bottom: 20px;
	}

	.form input[type='text'] {
		padding: 5px 10px;
	}

	.form button {
		padding: 3.5px 10px;
	}
</style>
